import { getStorageItem, STORAGE_KEY } from '@utils/storage';
import { InternalAxiosRequestConfig } from 'axios';

export const requestInterceptor = async (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
  try {
    const accessToken = getStorageItem(STORAGE_KEY.ACCESS_TOKEN);
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
  } catch (error) {
    return Promise.reject(error);
  }

  return config;
};
